var app = angular.module("leonardo");

var TitleTemplate = function($scope) {

  $scope.$on('parent_name', function (event, data) {
    $scope.template_parent = data;
  });
};

app.controller('TitleTemplate', ['$scope', TitleTemplate]);
